import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry configuration - prevent infinite loops
      // TODO: Replace any with a typed error shape once API response types are defined.
      retry: (failureCount, error: any) => {
        // Don't retry on 4xx errors (client errors)
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        // Don't retry on 5xx errors (server errors) - they won't fix themselves
        if (error?.response?.status >= 500) {
          return false;
        }
        // Only retry network errors once
        return failureCount < 1;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 3000),
      
      // Cache configuration — data is fresh for 5 minutes, kept for 30 minutes
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,

      // Prevent aggressive refetching
      refetchOnWindowFocus: false,
      // Refetch on reconnect
      refetchOnReconnect: true,

      // Network mode - prevent hanging on offline
      networkMode: 'online',
    },
    mutations: {
      // Mutations don't retry by default (prevent duplicate submissions)
      retry: 0,
      
      // Network mode for mutations
      networkMode: 'online',
    },
  },
});
